import { EVENT_TYPE, PLATFORM_TYPE_INFO, PLATFORM_TYPE } from "@root/config";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import _ from "lodash";
import { HeaderItem } from "@root/component/table-fixed-header/table-fixed-header.component";
export class AccountModel {
  id: number;
  thirdparty_type: string;
  thirdparty_type_cn: string;
  username: string;
  thirdparty_houses_count: string;
  create_time: string;
  constructor(options?: any) {
    this.id = options.id || 0;
    this.thirdparty_type_cn = options.thirdparty_type_cn || "";
    this.username = options.username || "";
    this.thirdparty_houses_count = options.thirdparty_houses_count || "";
    this.create_time = options.create_time || "";
  }
}

export class AccountProps {
  searchForm: FormGroup = this.fb.group({
    username: "",
    thirdparty_type: -1,
  });

  constructor(protected fb: FormBuilder) {}
}

export const PlatformBlackList = [
  PLATFORM_TYPE.MAYI,
  PLATFORM_TYPE.SHOP,
  PLATFORM_TYPE.TUJIAGYS,
  PLATFORM_TYPE.ZHUKEYUN
];

export const HeaderListForAccount: Array<HeaderItem> = [
  { name: "所属平台", i18nName: "channel.channel_belongs_to", width: 120 },
  { name: "账号", i18nName: "channel.account", width: 160 },
  { name: "房源数量", i18nName: "channel.channel_house_quantity", width: 120 },
  { name: "账号状态", i18nName: "channel.account_status", width: 250 },
  { name: "创建时间", i18nName: "word.create_time", width: 170 },
  { name: "操作", i18nName: "word.operate", width: 150 },
];
